const fromdata = [
  {
    inputdata: "",
    title: "原经销商名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    // inputtype: "input",
    inputtype: "selectautocompletes",
    width: "210px",
    disabled: false,
    lablewith: "110px",
  },
  {
    inputdata: "",
    title: "关联经销商名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    // inputtype: "input",
    inputtype: "selectautocompletes",
    width: "210px",
    lablewith: "110px",
    btx: false,
  },
];
export default fromdata;
